let MaterialHandler = function (___settings, ___handlers) {
  const THREE = require('../../../../externals/three'),
        MaterialHandlerInterface = require('../../../interfaces/handlers/MaterialHandlerInterface'),
        _handlers = ___handlers;

  let that,
      _helpers,
      _active = true;

  class MaterialHandler extends MaterialHandlerInterface {

    constructor() {
      super();
      that = this;

      _helpers = new (require('../../../helpers/handlers/MaterialHandlerHelpers'))(_handlers, {
        nameStandard: 'MeshPhongMaterial',
        nameSimple: 'MeshBasicMaterial'
      });

    }

    ////////////
    ////////////
    //
    // MaterialHandler API
    //
    ////////////
    ////////////

    /** @inheritdoc */
    pause() {
      _active = false;
    }

    /** @inheritdoc */
    resume() {
      _active = true;
    }

    /** @inheritdoc */
    destroy() {
      // destroy the material handler
    }

    
        

    /** @inheritdoc */
    getMaterial(properties) {
      return new THREE.MeshPhongMaterial(Object.assign({shininess: properties.metalness ? properties.metalness * 128.0 : 0.0}, properties));
    }

    /** @inheritdoc */
    getSimpleMaterial(properties) {
      return new THREE.MeshBasicMaterial(properties);
    }

    /** @inheritdoc */
    compile() {
      _handlers.renderingHandler.renderHidden();
      _helpers.checkMaterials();
    }
    



    /** @inheritdoc */
    adjustToBoundingSphere(bs) {
      _handlers.threeDManager.debug('This method is not implemented in this viewport.');
    }




    /** @inheritdoc */
    getEnvironmentMap() {
      _handlers.threeDManager.debug('This method is not implemented in this viewport.');
    }

    /** @inheritdoc */
    setSceneBackground(b) {
      _handlers.threeDManager.debug('This method is not implemented in this viewport.');
    }

    /** @inheritdoc */
    getSceneBackground() {
      _handlers.threeDManager.debug('This method is not implemented in this viewport.');
    }
  }

  return new MaterialHandler();
};

module.exports = MaterialHandler;